import { ICONS } from "../constants/icons";
import { IMAGES } from "../constants/images";
import useMoveTo from "../constants/navigation";

const NotFound = () => {
  const navigate = useMoveTo();

  return (
    <div className="bg-main min-h-screen flex flex-col overflow-auto p-4 md:p-8">
      {/* Header */}
      <div className="flex justify-between items-center">
        <button onClick={() => navigate(-1)}>
          <img
            src={ICONS.arrowBack}
            className="w-6 h-6 md:w-8 md:h-8 brightness-0 dark:invert"
            alt="Back"
          />
        </button>
        <h3 className="text-3xl md:text-4xl dark:text-white text-black font-bold">404 Error</h3>
        <div className="w-6 md:w-8" /> {/* Placeholder for spacing */}
      </div>

      {/* Content */}
      <div className="flex flex-col items-center justify-center text-center mt-16 md:mt-20 flex-1">
        <img
          src={IMAGES.notFound}
          className="w-48 md:w-64 lg:w-80 xl:w-96 object-contain mb-6"
          alt="Not Found"
        />

        <h3 className="text-3xl md:text-4xl dark:text-white text-black font-semibold mb-2">Oops!</h3>
        <h4 className="text-2xl md:text-3xl dark:text-white text-black mb-4">
          We couldn't find that page.
        </h4>
        <p className="text-base md:text-lg lg:text-xl dark:text-white text-gray-700 max-w-xl">
          Just hit the back button to try something else.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
